@if (!devFlag) {
  <mat-form-field style="width: 100%">
    <mat-select msInfiniteScroll (infiniteScroll)="getNextBatch()" [placeholder]="type" [formControl]="ctrl"
      (valueChange)="change($event)">
      <mat-option>
        <ngx-mat-select-search [formControl]="searchCtrl" placeholderLabel="search"
          noEntriesFoundLabel="No entry matches">
        </ngx-mat-select-search>
      </mat-option>
      @for (option of options$ | async; track option) {
        <mat-option [value]="option._id">
          @if (option?.name) {
            <span> {{ option?.name }}</span>
          }
          @if (option?.character) {
            <span> {{ option?.character }}</span>
          }
          <!-- {{ option?.name || option?.character }} -->
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (devFlag) {
  <mat-form-field style="width: 100%">
    <mat-select [placeholder]="type" [formControl]="ctrl" [(value)]="selectedVal" (valueChange)="change($event)">
      <mat-option>
        <ngx-mat-select-search [formControl]="searchCtrl" placeholderLabel="search"
          noEntriesFoundLabel="No entry matches">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option value=""> </mat-option>
      @for (option of list; track option) {
        <mat-option [value]="option._id">
          {{ option?.name || option?.character }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

<!--
<form class="search-form">
  <mat-form-field class="example-full-width"
    floatLabel="never" color="primary">
    <input matInput
      placeholder="State"
      aria-label="State"
      [formControl]="searchCtrl"
      [matAutocomplete]="auto"
      (input)="onInputChanged($event.target.value)"
      ><mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of options" [value]="option">{{ option }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form> -->